import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import Icon from '../../Icon';

var customFill = function customFill(seg, fillNum) {
  return new Array(seg).fill(fillNum).map(function (num, idx) {
    return num + idx;
  });
};

export var getShowData = function getShowData(_ref) {
  var currentPage = _ref.current,
      totalPage = _ref.totalPage,
      segmentNum = _ref.segmentNum,
      showSegment = _ref.showSegment,
      size = _ref.size;
  var pageList;

  if (showSegment && totalPage - segmentNum > 2) {
    var fSegment = segmentNum % 2 ? (segmentNum - 1) / 2 : segmentNum / 2;
    var bSegment = segmentNum % 2 ? (segmentNum - 1) / 2 : segmentNum / 2 - 1;

    if (currentPage - fSegment > 2 && currentPage + bSegment < totalPage - 1) {
      // 前后都省略
      pageList = [1, 'front'].concat(_toConsumableArray(customFill(segmentNum, currentPage - fSegment)), ['back', totalPage]);
    } else if (totalPage / 2 - currentPage > 0) {
      // 省略后边
      pageList = [].concat(_toConsumableArray(customFill(segmentNum + 1, 1)), ['back', totalPage]);
    } else {
      // 省略前边
      pageList = [1, 'front'].concat(_toConsumableArray(customFill(segmentNum + 1, totalPage - segmentNum)));
    }
  } else {
    pageList = customFill(totalPage, 1);
  }

  pageList = pageList.map(function (item) {
    return {
      type: typeof item === 'number' ? 'number' : item,
      show: typeof item === 'number' ? item : '...',
      selected: currentPage === item
    };
  }); // 增加前后操作按钮

  pageList.push({
    type: 'next',
    show: /*#__PURE__*/React.createElement(Icon, {
      size: size === 'small' ? 'mini' : 'small',
      className: "jmti-angle-right"
    })
  });
  pageList.unshift({
    type: 'prev',
    show: /*#__PURE__*/React.createElement(Icon, {
      size: size === 'small' ? 'mini' : 'small',
      className: "jmti-angle-left"
    })
  });
  return pageList;
}; // 切换页码，若当前页码超出最大范围，取最大值

export var getCurrentPage = function getCurrentPage(total, pageSize, currentPage) {
  var totalPageNum = Math.ceil(total / pageSize); // 输入不合法

  if (!(Number(currentPage) > 0)) {
    return null;
  }

  if (currentPage <= totalPageNum) return Number(currentPage);
  return totalPageNum;
};
export var getCurrentData = function getCurrentData(_ref2) {
  var total = _ref2.total,
      pageSize = _ref2.pageSize,
      showSegment = _ref2.showSegment,
      segmentNum = _ref2.segmentNum,
      showSizeChanger = _ref2.showSizeChanger,
      pageSizeOptions = _ref2.pageSizeOptions,
      showTotal = _ref2.showTotal,
      current = _ref2.current,
      size = _ref2.size;
  // 每页数据条数
  var truePageSize = Number(pageSize) > 0 ? Number(pageSize) : 10; // 页码总数

  var totalPage = Math.ceil((total || 1) / truePageSize); // pageSizeChanger list 配置

  pageSizeOptions = pageSizeOptions.map(Number);
  if (!pageSizeOptions.some(function (s) {
    return s === truePageSize;
  })) pageSizeOptions.push(truePageSize);
  pageSizeOptions.sort(function (val1, val2) {
    return val1 - val2;
  });
  var pageSizeList = showSizeChanger ? pageSizeOptions.map(function (item) {
    return {
      label: "".concat(item, "\u6761/\u9875"),
      value: item
    };
  }) : [];
  return {
    totalPage: totalPage,
    defaultSize: truePageSize,
    pageList: getShowData({
      current: current,
      totalPage: totalPage,
      segmentNum: segmentNum,
      showSegment: showSegment,
      size: size
    }),
    operateDisabled: {
      prevDisabled: current === 1,
      nextDisabled: current === totalPage
    },
    pageSizeList: pageSizeList,
    totalContent: showTotal(total, [(current - 1) * truePageSize + 1, current * truePageSize])
  };
};
export var operateConfig = function operateConfig(segmentNum) {
  return {
    front: -segmentNum,
    back: segmentNum,
    prev: -1,
    next: 1
  };
};
export var disabledConfig = function disabledConfig(_ref3) {
  var prevDisabled = _ref3.prevDisabled,
      nextDisabled = _ref3.nextDisabled;
  return {
    number: false,
    front: false,
    back: false,
    prev: prevDisabled,
    next: nextDisabled
  };
};